import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '@auth/auth-service';
import { NavBar } from '@components/nav-bar/nav-bar';

@Component({
  selector: 'abc-root',
  standalone: true,
  imports: [RouterOutlet, NavBar],
  templateUrl: 'app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private authService = inject(AuthService);

  protected readonly isImpersonating = this.authService.isImpersonating;
  protected readonly impersonatedUser = this.authService.impersonatedUser;
}
